/** Каталог публичных серверов (docs/api/openapi.yaml, раздел Discovery). */
import { api } from './api'
import { authed } from './auth'

export interface DiscoveryCard {
  guild_id: string
  slug: string
  name: string
  icon: string | null
  banner: string | null
  description: string
  category: string
  tags: string[]
  approximate_member_count: number
  approximate_presence_count: number
  state?: string
  reports_open?: number
}

export interface GuildPreview {
  id: string
  name: string
  icon: string | null
  banner: string | null
  description: string | null
  features: string[]
  approximate_member_count: number
  approximate_presence_count: number
  emojis: { id: string; name: string }[]
  stickers: { id: string; name: string }[]
}

export interface DiscoverySettings {
  listed: boolean
  state: string
  slug: string
  category: string
  tags: string[]
  description: string
  removed_reason: string | null
  problems: { key: string; text: string }[]
  url?: string
}

export interface Category {
  id: string
  name: string
}

export const discoveryApi = {
  categories: () => api<{ categories: Category[]; limits: Record<string, number> }>('/discovery/categories'),
  list: (params: { q?: string; category?: string; limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams()
    if (params.q) qs.set('q', params.q)
    if (params.category) qs.set('category', params.category)
    if (params.limit) qs.set('limit', String(params.limit))
    if (params.offset) qs.set('offset', String(params.offset))
    const tail = qs.toString()
    return api<{ guilds: DiscoveryCard[] }>(`/discovery/guilds${tail ? `?${tail}` : ''}`)
  },
  preview: (guildId: string) => api<GuildPreview>(`/guilds/${guildId}/preview`),
  bySlug: (slug: string) => api<GuildPreview>(`/discovery/guilds/${slug}`),
  settings: (guildId: string) => authed<DiscoverySettings>(`/guilds/${guildId}/discovery`),
  publish: (guildId: string, input: { category: string; tags: string[]; description: string }) =>
    authed<DiscoverySettings>(`/guilds/${guildId}/discovery`, { method: 'PUT', body: JSON.stringify(input) }),
  unpublish: (guildId: string) => authed<void>(`/guilds/${guildId}/discovery`, { method: 'DELETE' }),
  staff: (state?: string) => authed<{ guilds: DiscoveryCard[] }>(`/moderation/discovery${state ? `?state=${state}` : ''}`),
  setState: (guildId: string, state: string, reason = '') =>
    authed<void>(`/moderation/discovery/${guildId}`, { method: 'PATCH', body: JSON.stringify({ state, reason }) }),
}
